import { Group, Text } from '@mantine/core'
import React from 'react'
import { IconAlertTriangleFilled } from '@tabler/icons-react'
import { useTheme } from '../../components/ThemeProvider'

interface ReportItemProps {
  name: string
  value: string
  isNormal?: boolean
}

export default function ReportItem({ name, value, isNormal = true }: ReportItemProps) {
  const theme = useTheme()

  return (
    <Group justify={'space-between'}>
      <Group gap={2}>
        <Text size={'sm'} className={'whitespace-nowrap'}>
          {name}
        </Text>
      </Group>
      <Group gap={4}>
        {!isNormal && <IconAlertTriangleFilled size={16} className={'text-red-500'} />}
        <Text
          size={'sm'}
          className={'whitespace-nowrap'}
          style={{
            color: isNormal ? theme.primaryColor : 'red',
          }}
        >
          {value}
        </Text>
      </Group>
    </Group>
  )
}
